import { CSSProperties, ReactNode } from 'react';
import {
  Avatar as MUIAvatar,
  AvatarProps as MUIAvatarProps,
} from '@mui/material';

export type AtomMUIProps = {
  src?: string;
  children?: ReactNode;
  alt?: string;
  style?: CSSProperties;
};

type AvatarProps = AtomMUIProps;

export const Avatar = (props: AvatarProps) => {
  const MUIProps: MUIAvatarProps = props;

  return <MUIAvatar {...MUIProps} />;
};
